export var getProductScope = function getProductScope(productScopes) {
  if ('contentARI' in productScopes) {
    return {
      confluenceScopeId: {
        contentId: productScopes.contentARI,
        spaceId: productScopes.spaceARI
      }
    };
  } else {
    return {
      jiraScopeId: {
        projectId: productScopes.projectARI
      }
    };
  }
};